import React from 'react'

import { IconProps } from '../types'

export const BookAlt = ({ className, width = 16, height = 19, fill }: IconProps) => (
  <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 16 19">
    <path d="M15.875 13.0852V1.38523C15.875 0.822729 15.5375 0.485229 14.975 0.485229H3.5C1.5875 0.485229 0.125 1.94773 0.125 3.86023V15.1102C0.125 17.0227 1.5875 18.4852 3.5 18.4852H14.975C15.425 18.4852 15.875 18.1477 15.875 17.5852V17.0227C15.875 16.7977 15.7625 16.5727 15.5375 16.3477C15.425 15.7852 15.425 14.2102 15.5375 13.7602C15.7625 13.6477 15.875 13.4227 15.875 13.0852ZM13.5125 16.2352H3.5C2.825 16.2352 2.375 15.7852 2.375 15.1102C2.375 14.4352 2.9375 13.9852 3.5 13.9852H13.5125V16.2352Z" />
  </svg>
)
